// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610090709/js/" + chunkId + "." + {"44":"a5fcd996","225":"6ad2c37d","481":"acb5612c","486":"c4852c75","770":"cee1d85d"}[chunkId] + ".0.6412198089416025.chunk.js";
};